<template>
  <naj-modal
    ref="showDocumentsModel"
    :width="1500"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    @onClose="closeShowDocumentsModel"
  >
    <v-row>
      <v-col cols="2">
        <template v-for="(doc ,index) in documents">
          <div
            :key="index"
            :class="['row my-5 header-text document-entry py-2',{'outlined':doc.objectKey == (selectedDocument||{}).objectKey}]"
            @click="getDocument(index)"
          >
            <div class="py-1 text-c-green col-6">
              {{ local.caseFile.cards.document.attachmentName }}
            </div>
            <div class="py-1 text-info-value col-6 wrapping-text">
              {{ doc.name }}
            </div>

            <div class="py-1 text-c-green col-6">
              {{ local.caseFile.cards.document.typeDisplayName }}
            </div>
            <div class="py-1 text-info-value col-6">
              {{ doc.categoryName }}
            </div>

            <div class="py-1 text-c-green col-6">
              {{ local.caseFile.cards.document.dateDisplayName }}
            </div>
            <div class="py-1 text-info-value col-6">
              {{ toHijriDate( doc.creationDate) }}
            </div>
          </div>
        </template>
      </v-col>

      <v-col cols="10">
        <div class="preview-holder">
          <div
            v-if="loading"
            class="loader-holder"
          >
            <naj-loader></naj-loader>
          </div>
          <template v-else>
            <div
              v-if="document"
              class="attachment-file-viewer pdf-file"
            >
              <div
                v-if="selectedDocument.fileId"
                class="pdf-container"
              >
                <div class="pdf-wrapper">
                  <div class="pdf-holder">
                    <embed :src="fileUrl">
                  </div>
                </div>
              </div>
              <p
                v-else
                class="document-text"
              >
                {{ document }}
              </p>
            </div>
          </template>
        </div>
      </v-col>
    </v-row>

    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    />
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCaseActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate } from '@/helpers/utils';

export default {
  name: 'ShowDocumentsModel',
  props: {
    documents: {
      type: Array,
      required: true,
    },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
    selectedIndexProp: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
      selectedDocumentIndex: this.selectedIndexProp,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.document, false);
    },
    selectedDocument() {
      return ((this.documents || [])[this.selectedDocumentIndex]) || {};
    },
  },
  methods: {
    ...mapCaseActions(['getTrustedSourceAttachment']),
    toHijriDate,
    closeShowDocumentsModel() {
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.document = null;
      this.loading = false;
    },
    getDocument(index) {

      this.selectedDocumentIndex = index;

      this.loading = true;
      this.getTrustedSourceAttachment(this.selectedDocument.fileId)
        .then((attachment) => {
          this.document = `data:application/pdf;base64,${attachment}`;
        })
        .finally(
          () => (this.loading = false)
        );
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.showDocumentsModel.show();
        this.getDocument(this.selectedIndexProp);
      } else {
        this.$refs.showDocumentsModel.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-file-viewer {
  height: 100%;
  width: 100%;
}
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}
.judgements-wrapper {
  direction: rtl;
}
embed {
  width: 100%;
  height: 100%;
}
.document-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}

.document-entry {
  border: 2px solid #a2a2a2;
  border-radius: 5px;
  cursor: pointer;
  &.outlined {
    border: 4px solid #1fb9b8;
  }

  .text-info-value {
    font-size: 14px;
    font-weight: bold;
  }
  .wrapping-text {
    overflow-wrap: break-word;
  }
}
</style>